module.exports = __webpack_public_path__ + "img/1.fce5554c.jpg";